<template>
  <div class="panel-body">
    <div class="row">
      <div :class="account.is_team_member ? 'col-12' : 'col-6'">
        <div class="panel-content-inner">
          <h4 class="inner-title">{{ $t('account.settings.info_section.title') }}</h4>
          <div class="the-space" id="pixel-head">
            <p class="title-text">{{ $t('rentals.website.pixel_head') }}</p>

            <textarea class="form-control my-10" cols="100" rows="6" name="pixelHead"
                      :value="pixelHead"
                      @input="$emit('updateWebsiteSettings', 'google_pixel_head', $event.target.value)"/>
          </div>
          <div class="the-space" id="pixel-body">
            <p class="title-text">{{ $t('rentals.website.pixel_body') }}</p>

            <textarea class="form-control my-10" cols="100" rows="6" name="pixelBody"
                      :value="pixelBody"
                      @input="$emit('updateWebsiteSettings', 'google_pixel_body', $event.target.value)"/>
          </div>
          <div class="the-space" id="pixel-thank-you">
            <p class="title-text">{{ $t('rentals.website.pixel_thank_you') }}</p>

            <textarea class="form-control my-10" cols="100" rows="6" name="thankYou"
                      :value="thankYou"
                      @input="$emit('updateWebsiteSettings', 'google_pixel_thank_you', $event.target.value)"/>
          </div>
          <div class="the-space" id="custom-style">
            <p class="title-text">{{ $t('rentals.website.custom_style') }}</p>

            <textarea class="form-control my-10" cols="100" rows="6" name="customStyle"
                      :placeholder="placeHolderExample"
                      :value="customStyle"
                      @input="$emit('updateWebsiteSettings', 'custom_style', $event.target.value)"/>
          </div>
          <div v-show="!account.is_team_member" id="promo-code">
            <p class="title-text">{{$t('booking.promo.promo_code_title')}}</p>
            <div id="promo-code-section">
              <input v-model="promoOptions.code" type="text" class="form-control promo-child" name="promo-code" :placeholder="$t('booking.promo.promo_code')"/>
              <select v-model="promoOptions.type" class="form-control promo-child" name="promo-code-select">
                <option value="fixed">{{$t('booking.promo.fixed')}}</option>
                <option value="percent">{{$t('booking.promo.percent')}}</option>
              </select>
              <input v-model="promoOptions.amount" type="number" class="form-control promo-child" :placeholder="`${promoOptions.type === 'percent' ? '%' : account.currency.symbol}`"/>
              <button type="button" class="btn btn-primary promo-add-btn" @click="addPromoCode()">{{ $t('button.add') }}</button>
            </div>
          </div>
          <div v-show="!account.is_team_member" v-for="(list, index) in promoList" class="promo-list">
            <div class="promo-item">
              <input v-if="list.is_editing" v-model="list.code" type="text" class="form-control promo-child" name="promo-code"/>
              <span v-else>{{list.code}}</span>
            </div>
            <div class="promo-item">
              <select v-if="list.is_editing" v-model="list.type" class="form-control promo-child" name="promo-code-select">
                <option value="fixed">{{ $t('booking.promo.fixed') }}</option>
                <option value="percent">{{ $t('booking.promo.percent') }}</option>
              </select>
              <span v-else>{{ $t(`booking.promo.${list.type}`) }}</span>
            </div>
            <div class="promo-item">
              <input v-if="list.is_editing" v-model="list.amount" type="number" class="form-control promo-child"/>
              <span v-else>{{`${list.amount} ${list.type === 'percent' ? '%' : account.currency.symbol}`}}</span>
            </div>
            <div>
               <span class="cursor-pointer mr-10"
                 @click="list.is_editing ? savePromoCode(list.id, index) : editPromoCode(list.id, index)"
               >
                 <i v-if="list.is_editing" class="fa fa-check fa-2x" aria-hidden="true"></i>
                 <i v-else class="fa fa-pencil fa-2x" aria-hidden="true"></i>
               </span>
              <span class="cursor-pointer group-trash"
                    @click="deletePromoCode(list.id)"
              ><i class="fa fa-remove fa-2x"></i></span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6" v-if="!account.is_team_member">
        <v-loading :isLoading="smallLoading"></v-loading>
        <div class="panel-content-inner groups-panel" v-if="!smallLoading">
          <h4 class="inner-title">{{ $t('groups.list') }}</h4>
          <div class="row">
            <div class="form-group form-material col-6">
              <div v-if="rentalGroups.length" v-for="rentalGroup in rentalGroups" class="mb-5 col-12">
                <div class="d-flex align-items-center justify-content-center">
                  <input type="text" class="form-control"
                         v-model="rentalGroup.name"
                         @change="handleRentalGroupsChange(rentalGroup.id, rentalGroup.name)"
                         :disabled="!showGroupRentals || selectedGroup.id !== rentalGroup.id"
                         required
                  >
                  <span class="cursor-pointer edit-group mr-10"
                        v-if="!showGroupRentals || selectedGroup.id !== rentalGroup.id"
                        @click="editGroup(rentalGroup.id, rentalGroup.name)"
                  ><i class="far fa-pencil fa-2x"></i></span>
                  <span class="cursor-pointer group-trash"
                        v-if="!showGroupRentals || selectedGroup.id !== rentalGroup.id"
                        @click="deleteGroup(rentalGroup.id)"
                  ><i class="fa fa-remove fa-2x"></i></span>
                </div>
              </div>
              <div class="form-group form-material col-6">
                <button
                  type="button"
                  class="btn btn-primary waves-effect waves-classic btn-save mr-10 mt-10"
                  v-if="showGroupRentals"
                  @click="updateGroup()"
                >{{ $t('button.update') }}</button>
                <button
                  type="button"
                  class="btn btn-primary waves-effect waves-classic btn-save mr-10 mt-10"
                  v-if="!addNewGroup && !showGroupRentals"
                  @click="showNewGroupData()"
                >{{ $t('groups.add_new_group') }}</button>
              </div>
              <div class="form-group form-material col-12" v-if="addNewGroup">
                <input type="text" class="form-control" id="add-website-group" v-model="newGroup.name" autoFocus >
                <button
                  type="button"
                  class="btn btn-primary waves-effect waves-classic btn-save mt-10 mr-10"
                  @click="addGroup()"
                >{{ $t('button.add') }}</button>
                <button
                  type="button"
                  class="btn waves-effect waves-classic btn-cancel mt-10"
                  @click="resetGroupData()"
                >{{ $t('button.cancel') }}</button>
              </div>
            </div>
            <div class="form-group form-material col-6" v-if="showGroupRentals">
              <div class="checkbox-custom checkbox-primary" v-for="rentalItem in selectedGroupRentals">
                <input type="checkbox"
                       v-model="rentalItem.checked"
                       :id="rentalItem.name"
                >
                <label :for="rentalItem.name">{{ rentalItem.name }}</label>
              </div>
            </div>
            <div class="form-group form-material col-6" v-if="addNewGroup">
              <div class="checkbox-custom checkbox-primary" v-for="rentalItem in rentals">
                <input type="checkbox"
                       v-model="rentalItem.checked"
                       :id="rentalItem.name"
                >
                <label :for="rentalItem.name">{{ rentalItem.name }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
</template>
<script>
import rentalService from '../../../services/rental';
import _ from 'lodash';
import webSiteService from '../../../services/website';
import mixin from '../../../mixins/mixin';
import accountService from './../../../services/account';

export default {
  name: 'Website',
  props: [
    'pixelHead',
    'pixelBody',
    'thankYou',
    'customStyle',
    'rentalGroupsData',
  ],
  data() {
    return {
      placeHolderExample: '.rental-location {\n\tcolor: red; !important \n}',
      rentals: [],
      smallLoading: true,
      selectedGroup: {
        id: '',
      },
      newGroup: {
        name: '',
      },
      rentalGroups: [],
      showGroupRentals: false,
      changedData: false,
      addNewGroup: false,
      selectedGroupRentals: [],
      promoOptions: {
        code: '',
        type: 'fixed',
        amount: null,
      },
      promoList: [],
    };
  },
  components: {
    VLoading: require('components/loading/loading.vue'),
  },
  watch: {
    'account.web_key': function (newValue) {
      if (newValue) {
        this.getData();
      }
    },
  },
  mixins: [mixin],
  mounted() {
    if (this.smallLoading && this.account.web_key) {
      this.getData();
    }
    accountService.getPromoCodes(this);
  },
  methods: {
    addPromoCode() {
      if (this.promoOptions.code === '' || this.promoOptions.amount === null) {
        toastr.error(this.$t('booking.promo.fill_all_fields'));
        return;
      }
      const data = {
        code: this.promoOptions.code,
        type: this.promoOptions.type,
        amount: this.promoOptions.amount,
      };
      accountService.createPromoCode(this, data);
      this.promoOptions.code = '';
      this.promoOptions.type = 'fixed';
      this.promoOptions.amount = null;
    },
    deletePromoCode(id) {
      accountService.deletePromoCode(this, id);
    },
    editPromoCode(id, index) {
      const promoList = _.cloneDeep(this.promoList);
      promoList[index].is_editing = true;
      this.promoList = promoList;
    },
    savePromoCode(id, index) {
      const promoList = this.promoList.find(list => (list.id === id));
      const data = {
        id: promoList.id,
        promo_code: promoList.code,
        type: promoList.type,
        amount: promoList.amount,
      };
      accountService.updatePromoCode(this, data, index);
    },
    addGroup() {
      if (!this.newGroup.name) {
        toastr.error(this.$t('groups.name_required'));
        return;
      }
      if (this.rentalGroups.find(group => group.name === this.newGroup.name)) {
        toastr.error(this.$t('groups.name_exists'));
        return;
      }
      const allRentals = _.cloneDeep(this.rentals);
      const checkedRentals = allRentals.filter(r => r.checked === true);
      this.newGroup.web_site_rentals = checkedRentals.map(rental => rental.id);
      this.smallLoading = true;
      webSiteService.createRentalGroup(this, this.newGroup);
      this.resetGroupData();
    },
    editGroup(groupId, groupName) {
      if (this.showGroupRentals && groupId === this.selectedGroup.id) {
        this.showGroupRentals = false;
        return;
      }
      this.addNewGroup = false;
      this.showGroupRentals = true;
      this.selectedGroup.id = groupId;
      this.selectedGroup.name = groupName;
      const group = this.rentalGroups.find(g => g.id === groupId);
      const initialRentals = group.web_site_rentals.length ? _.cloneDeep(group.web_site_rentals) : [];
      group.web_site_rentals = _.cloneDeep(this.rentals);
      group.web_site_rentals.forEach((groupRental) => {
        groupRental.checked = false;
        if (initialRentals.length) {
          if (initialRentals.find(r => r.rental_id === groupRental.id && r.group_id)) {
            groupRental.checked = true;
          }
          if (initialRentals.find(r => r.id === groupRental.id && (r.checked === true || r.pivot))) {
            groupRental.checked = true;
          }
        }
      });
      this.selectedGroupRentals = [...group.web_site_rentals];
    },
    async deleteGroup(groupId) {
      this.smallLoading = true;
      await webSiteService.deleteRentalGroup(this, groupId);
      this.rentalGroups = [...this.rentalGroups.filter(rentalGroup => rentalGroup.id !== groupId)];
      this.smallLoading = false;
    },
    resetGroupData() {
      this.newGroup = {};
      this.rentals.forEach((rental) => {
        rental.checked = false;
      });
      this.rentals = [...this.rentals];
      this.showGroupRentals = false;
      this.addNewGroup = false;
    },
    handleRentalGroupsChange(groupId = null, groupName = null) {
      if (groupId && groupName) {
        this.selectedGroup.name = groupName;
      }
    },
    showNewGroupData() {
      this.addNewGroup = true;
    },
    async updateGroup() {
      const rentalsList = _.clone(this.selectedGroupRentals);
      const checkedRentals = rentalsList.filter(rental => rental.checked === true);
      const checkedRentalIds = checkedRentals.map(rental => rental.id);
      this.smallLoading = true;
      const newData = { ...this.selectedGroup, web_site_rentals: [...checkedRentalIds] };
      await webSiteService.updateRentalGroup(this, this.selectedGroup.id, newData);
      this.showGroupRentals = false;
      this.smallLoading = false;
    },
    getGroupsData() {
      this.smallLoading = true;
      webSiteService.getGroupsWithRentals(this, this.account.web_key, true);
    },
    getData() {
      rentalService.getRentalsList(this);
      this.getGroupsData();
    },
  },
  computed: {
    account() {
      return this.$store.state.account;
    },
  },
};
</script>



// WEBPACK FOOTER //
// Website.vue?a4e3c1c8